import { Loader2 } from "lucide-react";

function LoadingAdminUsers() {
    return (
        <div className="loading-state">
            <Loader2 className="spin" size={40} />
            <p>Loading Admin Users...</p>
        </div>
    );
}

export default LoadingAdminUsers;